import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemClusterTraffic } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const useClusterTraffic = (days) => {
  const { data: traffic, isLoading } = useQuery({
    queryKey: ["cluster", "traffic", days],
    queryFn: () => defaultOnError(
      SystemClusterTraffic.get(days, false),
      "Loading cluster traffic failed with status",
      "Could not load cluster traffic"
    ),
    enabled: !!days,
    placeholderData: keepPreviousData
  });
  return { traffic, isLoading };
};
export default useClusterTraffic;
